// src/utils/format.ts
// ─────────────────────────────────────────────────────────────────────────────
// Shared formatting utilities used across the app.
// ─────────────────────────────────────────────────────────────────────────────

/** Format a number as £ with comma separators, zero decimal places. e.g. £37,700 */
export function formatCurrency(n: number): string {
  return n.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

/** Format a number as £Xk shorthand. e.g. £443k */
export function formatCurrencyK(n: number): string {
  return n >= 1000 ? `£${(n / 1000).toFixed(0)}k` : formatCurrency(n);
}

/** Format a number as a percentage string. e.g. "4.5%" */
export function formatPct(n: number): string {
  return `${(n * 100).toFixed(1)}%`;
}

/**
 * Format a raw number with comma separators (no £ prefix).
 * Returns '' for 0/NaN so placeholder shows.  e.g. 42885 → "42,885"
 */
export function commaFormat(n: number): string {
  if (!n || isNaN(n)) return '';
  return n.toLocaleString('en-GB');
}

/**
 * Strip commas from a formatted string and parse to number.
 * e.g. "42,885" → 42885
 */
export function parseComma(s: string): number {
  return parseFloat(s.replace(/,/g, '')) || 0;
}
